import { render } from "./NcrmCompanyDetails.vue?vue&type=template&id=d9e9f3b4&scoped=true"
import script from "./NcrmCompanyDetails.vue?vue&type=script&lang=js"
export * from "./NcrmCompanyDetails.vue?vue&type=script&lang=js"

import "./NcrmCompanyDetails.vue?vue&type=style&index=0&id=d9e9f3b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e9f3b4"]])

export default __exports__